import { AritoIcon } from '@/components/custom/arito/icon';
import { NavMenu } from '../types';

export const tongHopMenu: NavMenu = {
  title: 'Tổng hợp',
  items: [
    {
      title: 'Hạch toán',
      group: 0,
      items: [
        {
          title: 'Phiếu kế toán',
          icon: <AritoIcon icon={843} />,
          href: '/tong-hop/hach-toan/phieu-ke-toan'
        },
        {
          title: 'Phiếu kế toán theo nghiệp vụ',
          icon: <AritoIcon icon={843} />,
          href: '/tong-hop/hach-toan/phieu-ke-toan-theo-nghiep-vu'
        },
        {
          title: 'Xử lý giao dịch chờ duyệt',
          icon: <AritoIcon icon={788} />,
          href: '/tong-hop/hach-toan/xu-ly-giao-dich-cho-duyet'
        }
      ]
    },
    {
      title: 'Bút toán cuối kỳ',
      group: 0,
      items: [
        {
          title: 'Bút toán phân bổ',
          icon: <AritoIcon icon={52} />,
          href: '/tong-hop/but-toan-cuoi-ky/but-toan-phan-bo'
        },
        {
          title: 'Bút toán kết chuyển',
          icon: <AritoIcon icon={51} />,
          href: '/tong-hop/but-toan-cuoi-ky/but-toan-ket-chuyen'
        },
        {
          title: 'Bút toán hủy',
          icon: <AritoIcon icon={866} />,
          href: '/tong-hop/but-toan-cuoi-ky/but-toan-huy'
        }
      ]
    },
    {
      title: 'Tính lại',
      items: [
        {
          title: 'Số dư tồn kho',
          icon: <AritoIcon icon={167} />,
          href: '/tong-hop/tinh-lai/so-du-ton-kho'
        },
        {
          title: 'Số dư tài khoản',
          icon: <AritoIcon icon={167} />,
          href: '/tong-hop/tinh-lai/so-du-tai-khoan'
        },
        {
          title: 'Số dư tức thời tài khoản',
          icon: <AritoIcon icon={167} />,
          href: '/tong-hop/tinh-lai/so-du-tuc-thoi-tai-khoan'
        },
        {
          title: 'Số dư tức thời tồn kho',
          icon: <AritoIcon icon={167} />,
          href: '/tong-hop/tinh-lai/so-du-tuc-thoi-ton-kho'
        }
      ]
    },
    /* {
      title: 'Khai báo',
      icon: <AritoIcon icon={57} />,
      group: 0,
      items: [
        {
          title: 'Khai báo bút toán phân bổ',
          icon: <AritoIcon icon={399} />,
          href: '/tong-hop/khai-bao/khai-bao-but-toan-phan-bo'
        },
        {
          title: 'Khai báo bút toán kết chuyển',
          icon: <AritoIcon icon={399} />,
          href: '/tong-hop/khai-bao/khai-bao-but-toan-ket-chuyen'
        }
      ]
    }, */
    {
      title: 'Đầu kỳ',
      icon: <AritoIcon icon={195} />,
      group: 0,
      items: [
        {
          title: 'Số dư đầu kỳ tài khoản và đối tượng',
          icon: <AritoIcon icon={196} />,
          href: '/tong-hop/dau-ky/so-du-dau-ky-tai-khoan-va-doi-tuong'
        },
        {
          title: 'Số dư đầu kỳ hóa đơn đầu vào',
          icon: <AritoIcon icon={558} />,
          href: '/tong-hop/dau-ky/so-du-dau-ky-hoa-don-dau-vao'
        },
        {
          title: 'Số dư đầu kỳ hóa đơn đầu ra',
          icon: <AritoIcon icon={558} />,
          href: '/tong-hop/dau-ky/so-du-dau-ky-hoa-don-dau-ra'
        },
        {
          title: 'Chứng từ thanh toán đầu kỳ hoá đơn đầu vào',
          icon: <AritoIcon icon={0} />,
          href: '/tong-hop/dau-ky/chung-tu-thanh-toan-dau-ky-hoa-don-dau-vao'
        },
        {
          title: 'Tồn kho đầu kỳ (vật tư, sản phẩm)',
          icon: <AritoIcon icon={437} />,
          href: '/tong-hop/dau-ky/ton-kho-dau-ky-vat-tu-san-pham'
        }
      ]
    },
    {
      title: 'Tra cứu',
      icon: <AritoIcon icon={69} />,
      group: 0,
      items: [
        {
          title: 'Bảng kê chứng từ',
          icon: <AritoIcon icon={764} />,
          href: '/tong-hop/tra-cuu/bang-ke-chung-tu'
        },
        {
          title: 'Bảng kê chứng từ theo đối tượng',
          href: '/tong-hop/tra-cuu/bang-ke-chung-tu-theo-doi-tuong'
        },
        {
          title: 'Tổng hợp phát sinh theo đối tượng',
          href: '/tong-hop/tra-cuu/tong-hop-phat-sinh-theo-doi-tuong'
        },
        {
          title: 'Bảng cân đối phát sinh theo đối tượng',
          icon: <AritoIcon icon={764} />,
          href: '/tong-hop/tra-cuu/bang-can-doi-phat-sinh-theo-doi-tuong'
        }
      ]
    },
    {
      title: 'Sổ kế toán',
      icon: <AritoIcon icon={131} />,
      group: 0,
      items: [
        {
          title: 'Sổ nhật ký chung',
          icon: <AritoIcon icon={767} />,
          href: '/tong-hop/so-ke-toan/so-nhat-ky-chung'
        },
        {
          title: 'Sổ cái của một tài khoản',
          href: '/tong-hop/so-ke-toan/so-cai-cua-mot-tai-khoan'
        },
        {
          title: 'Sổ chi tiết của một tài khoản',
          href: '/tong-hop/so-ke-toan/so-chi-tiet-cua-mot-tai-khoan'
        },
        {
          title: 'Sổ cái lên cho nhiều tài khoản',
          icon: <AritoIcon icon={531} />,
          href: '/tong-hop/so-ke-toan/so-cai-len-cho-nhieu-tai-khoan'
        },
        {
          title: 'Sổ chi tiết lên cho nhiều tài khoản',
          href: '/tong-hop/so-ke-toan/so-chi-tiet-len-cho-nhieu-tai-khoan'
        },
        {
          title: 'Sổ tổng hợp chữ T lên cho nhiều tài khoản',
          href: '/tong-hop/so-ke-toan/so-tong-hop-chu-t-len-cho-nhieu-tai-khoan'
        },
        {
          title: 'Báo cáo số dư tài khoản',
          icon: <AritoIcon icon={764} />,
          href: '/tong-hop/so-ke-toan/bao-cao-so-du-tai-khoan'
        }
      ]
    },
    {
      title: 'Báo cáo tài chính',
      icon: <AritoIcon icon={116} />,
      group: 0,
      items: [
        {
          title: 'Báo cáo kết quả sản xuất kinh doanh',
          icon: <AritoIcon icon={231} />,
          href: '/tong-hop/bao-cao-tai-chinh/bao-cao-ket-qua-hoat-dong-kinh-doanh'
        },
        {
          title: 'Bảng cân đối phát sinh tài khoản',
          icon: <AritoIcon icon={764} />,
          href: '/tong-hop/bao-cao-tai-chinh/bang-can-doi-phat-sinh-tai-khoan'
        },
        {
          title: 'Bảng cân đối kế toán',
          icon: <AritoIcon icon={764} />,
          href: '/tong-hop/bao-cao-tai-chinh/bang-can-doi-ke-toan'
        },
        {
          title: 'Báo cáo lưu chuyển tiền trực tiếp',
          icon: <AritoIcon icon={776} />,
          href: '/tong-hop/bao-cao-tai-chinh/bao-cao-luu-chuyen-tien-truc-tiep'
        },
        {
          title: 'Báo cáo lưu chuyển tiền gián tiếp',
          href: '/tong-hop/bao-cao-tai-chinh/bao-cao-luu-chuyen-tien-te-gian-tiep'
        }
      ]
    },
    {
      title: 'Quản trị phí',
      icon: <AritoIcon icon={625} />,
      group: 0,
      items: [
        {
          title: 'Bảng kê chứng từ theo mã phí, bộ phận',
          icon: <AritoIcon icon={764} />,
          href: '/tong-hop/quan-tri-phi/bang-ke-chung-tu-theo-ma-phi-bo-phan'
        },
        {
          title: 'Bảng tổng hợp phát sinh theo mã phí, bộ phận',
          href: '/tong-hop/quan-tri-phi/bang-tong-hop-phat-sinh-theo-ma-phi-bo-phan'
        },
        {
          title: 'Báo cáo tổng hợp chi phí trong kỳ',
          href: '/tong-hop/quan-tri-phi/bao-cao-tong-hop-chi-phi-trong-ky'
        },
        {
          title: 'Báo cáo tổng hợp chi phí so sánh giữa 2 kỳ',
          href: '/tong-hop/quan-tri-phi/bao-cao-tong-hop-chi-phi-so-sanh-giua-2-ky'
        },
        {
          title: 'Báo cáo tổng hợp chi phí cho nhiều kỳ',
          href: '/tong-hop/quan-tri-phi/bao-cao-tong-hop-chi-phi-cho-nhieu-ky'
        }
      ]
    }
  ]
};
